export default __webpack_public_path__ + "static/media/repair.b5537573.svg";